import { create } from 'zustand';
import type { GeneratedMission } from '@bid/shared-types';
import { generateMission } from '@bid/bitd-data';
import { saveContent } from '@bid/client-storage';

interface MissionStore {
  generatedMission: GeneratedMission | null;
  selectedScoreType: string | null;
  primaryFaction: string | null;
  opposingFaction: string | null;
  isGenerating: boolean;
  generateMission: () => void;
  setScoreType: (type: string | null) => void;
  setPrimaryFaction: (faction: string | null) => void;
  setOpposingFaction: (faction: string | null) => void;
  saveMission: () => Promise<number | null>;
}

export const useMissionStore = create<MissionStore>((set, get) => ({
  generatedMission: null,
  selectedScoreType: null,
  primaryFaction: null,
  opposingFaction: null,
  isGenerating: false,

  generateMission: () => {
    set({ isGenerating: true });
    const { selectedScoreType, primaryFaction, opposingFaction } = get();

    const mission = generateMission({
      scoreType: selectedScoreType || undefined,
      primaryFaction: primaryFaction || undefined,
      opposingFaction: opposingFaction || undefined,
    });

    set({
      generatedMission: mission,
      isGenerating: false,
    });
  },

  setScoreType: type => {
    set({ selectedScoreType: type });
  },

  setPrimaryFaction: faction => {
    set({ primaryFaction: faction });
  },

  setOpposingFaction: faction => {
    set({ opposingFaction: faction });
  },

  saveMission: async () => {
    const { generatedMission } = get();
    if (generatedMission) {
      try {
        const id = await saveContent('mission', generatedMission.target, generatedMission);
        console.log('Mission saved with ID:', id);
        return id;
      } catch (error) {
        console.error('Error saving mission:', error);
        return null;
      }
    }
    return null;
  },
}));
